import React, { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { Image, Layer, Stage, Group } from 'react-konva';
import { ParentSize } from '@visx/responsive';
import useCanvasOverlayViewer from "./useCanvasOverlayViewer.js";
import useImageAdvanced from "./useImageAdvanced.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CanvasOverlayViewer(props) {
  const {
    imageUrl,
    layers,
    layersEnabled,
    onRender,
    context
  } = props;
  return /*#__PURE__*/_jsx(ParentSize, {
    children: ({
      width,
      height
    }) => {
      let scale;
      return /*#__PURE__*/_jsx(ImageStage, {
        context: context,
        height: height,
        width: width,
        imageUrl: imageUrl,
        layers: layers,
        layersEnabled: layersEnabled,
        onRender: onRender,
        scale: scale
      });
    }
  });
}
function ImageStage(props) {
  const {
    height,
    imageUrl,
    layers: pLayers,
    layersEnabled = true,
    onRender,
    width,
    context
  } = props;
  const {
    image,
    scale: imgScale
  } = useImageAdvanced(imageUrl, {
    width,
    height
  });
  const stageRef = useRef();
  const imageRef = useRef();
  const {
    layers
  } = useCanvasOverlayViewer({
    layers: pLayers,
    stage: stageRef.current,
    backgroundImageNode: imageRef.current,
    context
  });
  const setStageRef = useCallback(el => {
    if (stageRef.current !== el) {
      stageRef.current = el;
      onRender?.(el);
    }
  }, [onRender]);
  if (!image) {
    return null;
  }
  const offsetY = (height - image.height) / 2;
  const offsetX = (width - image.width) / 2;
  return /*#__PURE__*/_jsx(Stage, {
    ref: setStageRef,
    width: width || image.naturalWidth,
    height: height || image.naturalHeight,
    children: /*#__PURE__*/_jsxs(Layer, {
      offsetY: -offsetY,
      offsetX: -offsetX,
      children: [/*#__PURE__*/_jsx(Image, {
        ref: imageRef,
        image: image
      }), /*#__PURE__*/_jsx(Group, {
        visible: layersEnabled,
        scaleX: imgScale,
        scaleY: imgScale,
        children: layers
      })]
    })
  });
}